import React from 'react';

export interface TutorialCardProps {
  title: string;
  subtitle: string;
  body: string;
  accent: string;
  onClose: () => void;
  showSkip?: boolean;
}

/**
 * Single tutorial card modal for contextual first-visit tutorials
 */
const TutorialCard: React.FC<TutorialCardProps> = ({
  title,
  subtitle,
  body,
  accent,
  onClose,
  showSkip = true,
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        background: 'rgba(0, 0, 0, 0.92)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 28px',
        textAlign: 'center',
        animation: 'fadeIn 0.4s ease',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '400px',
          width: '100%',
          background: 'linear-gradient(135deg, #12122a, #1a1a3e)',
          borderRadius: '20px',
          border: '1px solid rgba(201,168,76,0.2)',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        }}
      >
        {/* Skip button */}
        {showSkip && (
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'none',
              border: 'none',
              color: 'rgba(255,255,255,0.3)',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '8px',
              lineHeight: 1,
            }}
          >
            ×
          </button>
        )}

        {/* Title */}
        <h2
          style={{
            fontFamily: 'Cinzel, serif',
            fontSize: '24px',
            fontWeight: 700,
            color: '#fff',
            margin: '0 0 8px',
            letterSpacing: '0.5px',
          }}
        >
          {title}
        </h2>

        {/* Subtitle */}
        <p
          style={{
            fontSize: '13px',
            color: accent,
            fontStyle: 'italic',
            margin: '0 0 24px',
            letterSpacing: '0.5px',
          }}
        >
          {subtitle}
        </p>

        {/* Body */}
        <p
          style={{
            fontSize: '15px',
            color: 'rgba(255,255,255,0.7)',
            lineHeight: 1.7,
            margin: '0 0 32px',
          }}
        >
          {body}
        </p>

        {/* Got It button */}
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '14px',
            background: `linear-gradient(135deg, ${accent}, ${accent}dd)`,
            border: 'none',
            borderRadius: '12px',
            color: accent === '#2ecc71' || accent === '#48c9b0' ? '#0a0a1a' : '#fff',
            fontSize: '16px',
            fontWeight: 700,
            cursor: 'pointer',
            letterSpacing: '0.5px',
            transition: 'all 0.2s',
          }}
        >
          Got It
        </button>
      </div>

      {/* ZEAL watermark */}
      <p
        style={{
          position: 'absolute',
          bottom: '32px',
          fontSize: '11px',
          color: 'rgba(201,168,76,0.15)',
          letterSpacing: '4px',
          textTransform: 'uppercase',
        }}
      >
        Zeal Genesis
      </p>
    </div>
  );
};

export default TutorialCard;
